import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Work } from './pages/Work';
import { Blog } from './pages/Blog';
import { BlogDetail } from './pages/BlogDetail';
import { Contact } from './pages/Contact';
import { Studio } from './pages/Studio';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
        <Route path="/work" element={<Work data-id="element-6" />} data-id="element-5" />
        <Route path="/blog" element={<Blog data-id="element-8" />} data-id="element-7" />
        <Route path="/blog/:id" element={<BlogDetail data-id="element-10" />} data-id="element-9" />
        <Route path="/contact" element={<Contact data-id="element-12" />} data-id="element-11" />
        <Route path="/studio" element={<Studio data-id="element-14" />} data-id="element-13" />
      </Routes>
    </Router>;
}